"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSNOnPrimaryComponent = void 0;
const generic_content_service_1 = require("../services/generic.content.service");
const account_service_1 = require("../services/account.service");
class CSNOnPrimaryComponent {
    constructor(genericContentService, accountService) {
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.isSecondary = false;
        this.isProspect = false;
        this.isHotlined = false;
    }
    ngOnInit() {
        this.getAccountDetailsInfo();
    }
    secondaryCustomerInfo() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericContentSecondaryDashboard').subscribe((data) => {
            this.secondaryCustomerInformation = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    prospectCustomerInfo() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericContentProspectCustomerDashboard').subscribe((data) => {
            this.prospectCustomerInformation = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    hotlinedCustomerInfo() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericContentHotlinedDashboard').subscribe((data) => {
            this.hotlinedCustomerInformation = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    fiberInactiveCustomerInfo() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericContentInactiveDashboard').subscribe((data) => {
            this.fiberInactiveCustomerInformation = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getAccountDetailsInfo() {
        this.accountService.getAccountDetails().subscribe((res) => {
            this.isHotlined = res.accountHotlined;
            this.isProspect = res.prospectProfile;
            if (res.profileType === 'SECONDARY') {
                this.isSecondary = true;
            }
            if (res.fiberAccount) {
                this.accountStatus();
            }
        });
        if (this.isHotlined === true) {
            this.hotlinedCustomerInfo();
        }
        else if (this.isProspect === true) {
            this.prospectCustomerInfo();
        }
        else if (this.isSecondary === true) {
            this.secondaryCustomerInfo();
        }
    }
    accountStatus() {
        this.accountService.getFiberAccDetails()
            .subscribe((res) => {
            if (res !== null) {
                this.fiberStatus = res.accountStatus;
                if (this.fiberStatus === 'Pending' || this.fiberStatus === 'Inactive') {
                    this.deactivateStatus = true;
                    this.fiberInactiveCustomerInfo();
                }
                else {
                    this.deactivateStatus = false;
                }
            }
        }, (err) => {
        });
    }
}
exports.CSNOnPrimaryComponent = CSNOnPrimaryComponent;
//# sourceMappingURL=nonprimary.component.js.map